import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Props } from "./types";
import styles from "./styles.scss";
import { toFixed } from "@common/projectSection/utils";

function WorkloadSection({ project }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.workload_allocatedTime")}
        </div>
        <div className={styles.sectionValue}>
          <p
            className={classNames(styles.text, {
              [styles.warning]: project.totalSumOfTimeAllocatedOnTheProject < 0,
            })}
          >
            {toFixed(project.totalSumOfTimeAllocatedOnTheProject)} h
          </p>
        </div>
      </div>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.workload_spentTime")}
        </div>
        <div className={styles.sectionValue}>
          <p
            className={classNames(styles.text, {
              [styles.warning]: project.totalOfTimesSpentInProject < 0,
            })}
          >
            {toFixed(project.totalOfTimesSpentInProject)} h
          </p>
        </div>
      </div>
      <div className={styles.sectionRow}>
        <div className={styles.sectionLabel}>
          {t("projectSection.columnNames.workload_remainingWork")}
        </div>
        <div className={styles.sectionValue}>
          <p
            className={classNames(styles.text, {
              [styles.warning]: project.totalOfRemainingTimeInProject < 0,
            })}
          >
            {toFixed(project.totalOfRemainingTimeInProject)} h
          </p>
        </div>
      </div>
    </div>
  );
}

export { WorkloadSection };
